export default "__VITE_ASSET__BfivXpPa__"